<template>
  <div class="profile" v-if="user">
    <div>
      <h1 class="text-capitalize-first mb-0">{{$t('profile')}}</h1>
    </div>
    <div class="block userinfo">
      <div class="d-flex flex-row justify-content-start align-items-center">
        <div class="icon">
            <img v-if="user?.avatarUrl" :src="user?.avatarUrl">
        </div>
        <div class="info">
          <span class="username">{{ user?.userLabel }}</span>
          <span class="email">{{ user?.email }}</span>
        </div>
      </div>
      <div class="buttons" style="display: none">
        <button class="btn btn-outline-secondary"><span class="text-capitalize-first">{{ $t('edit') }}</span></button>
      </div>
    </div>

    <div class="block user-league">
      <div class="d-flex flex-row justify-content-between align-items-center">
        <div class="d-flex flex-row justify-content-start">
          <div class="icon">
            <img alt="league" :src="`/img/leagues/${user?.userLeague.league}.png`">
          </div>
          <div class="info">
            <span class="league-name">{{ $t(`leagues.titles.${user?.userLeague.league}`) }}</span>
            <div>
              <img src="/img/timer.svg"> <span class="recal-text" v-html="nextCalcLabel"></span>
            </div>

          </div>
        </div>
        <div class="buttons">
          <button @click="router.push({name: 'leagueDescriptions'})" class="btn btn-outline-secondary"><span class="text-capitalize-first">{{ $t('about') }}</span></button>
        </div>
      </div>
      <div class="d-flex flex-column gap-xs">
        <div class="d-flex flex-column">
        <div class="d-flex justify-content-between leagues-stat">
          <span>{{ $t('bets') }}</span>
          <span class="font-monospace d-flex align-items-center">
            <img src="/img/coins/gold_coin.svg" style="height: 14px; margin-right: 4px">
            {{numberFormatter.formatNumber(user?.userLeague.betSum)}} / {{numberFormatter.formatNumber(user?.userLeague.nextBetSum)}}
          </span>
        </div>
        <LeagueProgressBar class="mt-1" :progress="100 * (parseFloat(user?.userLeague.betSum.amount)/parseFloat(user?.userLeague.nextBetSum.amount))"/>
        </div>

        <div class="d-flex flex-column" v-if="user?.userLeague.nextDepositsCount > 0">
          <div class="d-flex justify-content-between leagues-stat" >
            <span>{{ $t('purchases') }}</span>
            <span class="font-monospace">{{numberFormatter.formatNumber(user?.userLeague.depositsCount)}} / {{numberFormatter.formatNumber(user?.userLeague.nextDepositsCount)}}</span>
          </div>
          <LeagueProgressBar  :progress="100*(user?.userLeague.depositsCount/user?.userLeague.nextDepositsCount)" class="mt-1"/>
        </div>

        <div class="d-flex justify-content-between leagues">
          <span>{{ $t(`leagues.short_titles.${user?.userLeague.league}`) }}</span>
          <span>{{ $t(`leagues.short_titles.${user?.userLeague.nextLeague}`) }}</span>
        </div>
      </div>

    </div>

    <div class="oauth-accounts">
      <div>
        <div class="header ms-0 mb-0">
          <span class="text-capitalize-first">{{$t('connected_accounts')}}</span>
        </div>
        <span class="subtext">Secure your account and log in faster</span>
      </div>

      <div class="block oauth-account" v-for="oauth in user?.oauthUsers">
        <div class="provider">
          <img :alt="oauth.provider" :src="`/img/${oauth.provider.toLowerCase()}.svg`">
          <span class="text-capitalize-first">{{oauth.provider.toLowerCase()}}</span>
        </div>
        <div>
          <span v-if="oauth.id" class="text-capitalize-first text-primary">{{$t('connected')}}</span>
          <button v-else @click="connect(oauth.provider)" class="btn btn-primary"><span class="text-capitalize-first">{{$t('connect')}}</span></button>
        </div>

      </div>
    </div>
    <button @click="logout" class="btn btn-outline-danger">{{ $t('logout') }}</button>

  </div>
</template>
<style scoped>
.profile {
  display: flex;
  flex-direction: column;
  margin: 0 var(--margin-normal);
  gap: var(--margin-xl);

  .user-league {
    display: flex;
    flex-direction: column;
    .leagues {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0%;
      text-align: right;
    }

    .leagues-stat {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0%;
      text-align: right;
      color: #FFFFFF99;
    }

    .icon {
      margin-right: var(--margin-normal);
      img {
        width: 60px;
        height: 60px;
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      .league-name {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
      }
      .recal-text {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0%;
        color: #FFFFFF99;
      }
    }
  }

  .oauth-accounts {
    display: flex;
    flex-direction: column;
    gap: var(--margin-sm);

    .subtext {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0%;
    }

    .oauth-account {
      display: flex;
      justify-content: space-between;

      .provider {
        display: flex;
        gap: var(--margin-xs);
        align-items: center;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
      }
    }
  }
  .userinfo {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .info {
      display: flex;
      flex-direction: column;
      .username {
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0%;
      }
      .email {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0%;
      }
    }

    .icon {
      width: 60px;
      height: 60px;
      border-radius: 1000px;
      background-color: #000000;
      margin-right: var(--margin-normal);

      img {
        width: 100%;
        height: 100%;
        border-radius: 1000px;
      }
    }
  }
  .block {
    border-radius: var(--border-radius);
    background-color: var(--header-bg);
    padding: var(--margin-normal);
  }

}

</style>
<script lang="ts" setup>
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {computed, onMounted} from "vue";
import UserDTO from "@/models/UserDTO";
import {recalculationInLabelText} from "@/service/DateHelper";
import { loadGoogleScript } from '@/composables/useGoogleSignIn'
import { loadFacebookScript } from '@/composables/useFacebookSignIn'
import { loadAppleScript } from '@/composables/useAppleSignIn'
import {api} from "@/service/APIClient";
import TokenOAuthRequestDTO from "@/models/request/TokenOAuthRequestDTO";
import {reactive} from "@vue/reactivity";
import LeagueProgressBar from "@/components/LeagueProgressBar.vue";
import {numberFormatter} from "@/service/NumberFormatter";

const store = useStore()
const router = useRouter()

const state = reactive({
  googleClient: null as any
});

const user = computed((): UserDTO|null => {
  return store.getters.getUser
})

const nextCalcLabel = computed(() => {
  if (!user.value) {
    return '';
  }

  return recalculationInLabelText(user.value?.userLeague.nextCalcAt)
})

const connect = (provider: string) => {
  switch (provider) {
    case 'GOOGLE':
      return state.googleClient.requestAccessToken();
    case 'APPLE':
      return connectApple();
    case 'FACEBOOK':
      return connectFacebook();
  }
}

const connectApple = async () => {
  try {
    const data = await AppleID.auth.signIn()
    const idToken = data.authorization.id_token
    await api.call.token.oauthConnect({ type: 'APPLE', payload: idToken } as TokenOAuthRequestDTO)
    await store.dispatch('updateUser')
  } catch (e) {
  }
}

const connectFacebook = () => {
  window.FB.login(async (response:any) => {
    if (response.authResponse?.signedRequest) {
      await api.call.token.oauthConnect({ type: 'FACEBOOK', payload: response.authResponse.signedRequest } as TokenOAuthRequestDTO)
      await store.dispatch('updateUser')
    }
  }, { scope: 'public_profile,email' })
}

onMounted(async () => {
  await loadGoogleScript();
  state.googleClient = window.google.accounts.oauth2.initTokenClient({
    client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
    callback: async (response: any) => {

      await api.call.token.oauthConnect({type: 'GOOGLE', payload: response.access_token} as TokenOAuthRequestDTO)
      await store.dispatch('updateUser')
    },
  });

  await loadFacebookScript(process.env.VUE_APP_FACEBOOK_APP_ID as string);
  await loadAppleScript(process.env.VUE_APP_APPLE_CLIENT_ID as string);
});

const logout = () => {
  store.dispatch('logout')
  window.location.href = '/';
}
</script>
